* {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
}

/* @media (min-resolution: 200dpi) {
    body {
         zoom: 85%;
    }
}

@media (min-resolution: 300dpi) {
    body {
         zoom: 70%;
    }
} */